<!--
 * @Author: WGL 958897276@qq.com
 * @Date: 2025-06-16 17:36:15
 * @LastEditors: WGL 958897276@qq.com
 * @LastEditTime: 2025-08-18 15:08:33
 * @FilePath: /erp-admin/src/components/BaseFreezeStock/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <el-table :data="freezeList">
    <el-table-column
      :label="t('发货计划')"
      min-width="175"
      property="delivery_plan_info.code"
    />
    <el-table-column
      :label="t('关联订单')"
      min-width="175"
      property="sale_order_info.code"
    />
    <el-table-column
      align="center"
      :label="t('所属仓库')"
      min-width="90"
      property="repository_info.full_title"
    />
    <el-table-column
      align="center"
      :label="t('冻结数量')"
      min-width="80"
      property="num"
    />
    <el-table-column
      align="center"
      :label="t('订单日期')"
      property="sale_order_info.create_time"
      width="110"
    />
  </el-table>
</template>

<script>
  import { defineComponent, onMounted, ref } from 'vue'
  import request from '@/utils/request'
  import { t } from '@/utils/i18n'

  export default defineComponent({
    name: 'BaseProductFreeze',
    props: {
      scope: { type: Object, default: () => {} },
      text: { type: String, default: '' },
    },
    setup(props) {
      const freezeList = ref([])
      const handleGetDetail = (row) => {
        console.log('row', row)
        request({
          url: '/repository-freeze-log/index',
          method: 'get',
          params: {
            product_id: row.product_id || row.id,
            per_page: 10000,
          },
        }).then((res) => {
          console.log('res', res)
          freezeList.value = res?.data || []
        })
      }
      onMounted(() => {
        handleGetDetail(props.scope)
      })
      return {
        freezeList,
        handleGetDetail,
        t,
      }
    },
  })
</script>

<style scoped></style>
